export default __webpack_public_path__ + "83f3bce06e7f60d852e38575c7add8a0.svg";